export const getters = {
  systemRequisitions: state => state.requisitions,
  systemTransporter: state => state.transporter,
  systemTransportertrucks: state => state.transportertrucks,
  Requisition: state => state.systemRequisition
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/requisitions/getters.js